import { Injectable } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AuthenticationService } from './authentication.service';
import { from } from 'rxjs';

@Injectable()
export class PayHttpInterceptor implements HttpInterceptor {
	constructor(private authServie: AuthenticationService) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		return from(this.handleAccess(request, next));
	}

	private async handleAccess(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Promise<HttpEvent<any>> {
		const token = await this.authServie.token;
		let changedRequest = request;
		// HttpHeader object immutable - copy values
		const headerSettings: { [name: string]: string | string[] } = {};

		for (const key of request.headers.keys()) {
			headerSettings[key] = request.headers.getAll(key);
		}
		if (token) {
			headerSettings['Authorization'] = 'Bearer ' + token;
		}
		headerSettings['Content-Type'] = 'application/json';
		const newHeader = new HttpHeaders(headerSettings);

		changedRequest = request.clone({
			headers: newHeader,
		});
		return next.handle(changedRequest).toPromise();
	}
}
